// extracted by mini-css-extract-plugin
export default {"container":"Topup_container__MlvTk","credits":"Topup_credits__hEVsT","buy":"Topup_buy__YKWhc","buyDetails":"Topup_buyDetails__YnILi"};